<template>
    <div class="leaderboard__wrapper" :class="wrapperClass" :style="wrapperStyle" v-if="$store.state.leaderboard">
        <div v-for="group of activeRound.groups" :key="group.id">
            <leaderboard-group :value="group" is-single />
        </div>
    </div>
</template>

<script>

import LeaderboardGroup from './LeaderboardGroup';

export default {
    name: 'leaderboard',

    components: { LeaderboardGroup },

    props: {
        msg: String
    },

    data() {
        return {
            wrapperBackgroundImage: require("@/assets/img/sjoelen3.jpeg"),
        };
    },

    computed: {
        wrapperStyle() {
            return {
                backgroundImage: `url(${this.wrapperBackgroundImage})`,
                fontSize: this.$store.state.fontSize + "px",
            };
        },

        wrapperClass() {
            let countRounds = this.activeRound.groups.length ;
            if (countRounds > 4 && countRounds % 4 === 0) {
                return "";
            }
            if (countRounds >= 3 && countRounds <= 9 && countRounds % 3 === 0) {
                return "leaderboard__wrapper--3-col"
            }
            if (countRounds === 1) {
                return "leaderboard__wrapper--1-col"
            }
            if (countRounds <= 4) {
                return "leaderboard__wrapper--2-col"
            }
            return "";
        },

        activeRound() {

            if (! this.$store.state.leaderboard.activeRound) {
                return null;
            }
            
            // console.log(JSON.parse(JSON.stringify(this.$store.state.leaderboard.rounds)));
            let result = this.$store.state.leaderboard.rounds.find((round) => {
                return round.id === this.$store.state.leaderboard.activeRound.id;
            });

            result.groups.sort((a, b) => {
                if (a.name < b.name) { return -1; }
                if (a.name > b.name) { return 1; }
                return 0;
            });

            return result;
        },
    },

    mounted() {
        if (this.$route.params.id) {
            sessionStorage.setItem("boardId", this.$route.params.id)
        }
        this.autoScroll();
    },

    methods: {
        calcPoulePoints(score1, score2) {
            if (Number(score1) > Number(score2)) { return 3; }
            if (Number(score1) < Number(score2)) { return 0; }
            return 1;
        },
        smoothScrollTo(targetY, duration, callback) {
            const startY = window.scrollY;
            const distance = targetY - startY;
            let startTime = null;

            function animationStep(timestamp) {
                if (!startTime) startTime = timestamp;
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const ease = progress * (2 - progress); // Een eenvoudige easing-functie

                window.scrollTo(0, startY + distance * ease);

                if (elapsed < duration) {
                    requestAnimationFrame(animationStep);
                } else if (callback) {
                    callback();
                }
            }

            requestAnimationFrame(animationStep);
        },

        autoScroll() {
            const scrollDuration   = 5000;  // 5 seconden scrollen
            const pauseDuration    = 5000;  // 5 seconden pauze
            const intervalDuration = 90000; // 2 minuten interval

            const that = this;

            function scrollDown() {
                const targetY = document.body.scrollHeight - window.innerHeight; // Naar beneden
                that.smoothScrollTo(targetY, scrollDuration, () => {
                    setTimeout(scrollUp, pauseDuration);
                });
            }

            function scrollUp() {
                const targetY = 0; // Naar boven
                that.smoothScrollTo(targetY, scrollDuration, () => {
                    setTimeout(scrollDown, intervalDuration - scrollDuration * 2 - pauseDuration);
                });
            }

            scrollDown(); // Start de cyclus door naar beneden te scrollen
        },
    }
}
</script>

<style lang="scss" scoped>

    .leaderboard {
        &__wrapper {
            width: 100vw;
            min-height: 100vh;
            background-image: URL('/assets/img/sjoelen3.jpg');
            background-attachment: fixed;
            background-size: cover;
            padding: 10px 30px;
            gap: 10px;
            display: grid; 
            grid-auto-rows: 1fr;
            cursor: none;

            &:not(&--3-col):not(&--2-col):not(&--1-col) {
                grid-template-columns: repeat(4, 1fr); 
            }

            &--3-col {
                grid-template-columns: repeat(3, 1fr); 
            }
            &--2-col {
                grid-template-columns: repeat(2, 1fr); 
            }
            &--1-col {
                grid-template-columns: repeat(1, 1fr); 
            }
        }
    }
</style>
